import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { OidcUserStatus, useOidcAccessToken, useOidcUser } from '@axa-fr/react-oidc'

import Chat from 'features/chat/webchat/Chat'
import { getUserName } from 'utils/auth/oidcFunctions'
import { getDirectLine } from './functions'
import { getOidcConfigName } from 'utils/functions'
import { createDirectLine } from 'botframework-webchat'
import { FakeText } from '@totalsoft/rocket-ui'

const ChatLoggedIn = ({
  isAnonymous,
  urlConfig,
  chatbotName,
  displayInnerHeader = false,
  headerFollowupText,
  hideUploadButton = false,
  hideNewConversationButton = false,
  botAvatar,
  soundUrl,
  forceAutoscrollOnNewMessage,
  isDevelopment,
  headerChatVersion,
  emojiSet,
  refreshTokenTimeout
}) => {
  const { oidcUser, oidcUserLoadingState } = useOidcUser(getOidcConfigName())
  const { accessToken } = useOidcAccessToken(getOidcConfigName())
  const displayUserName = getUserName(oidcUser)

  const handleConnectToDirectline = useCallback(
    ({ userId, username, fullTokenUrl, getNewConversation, setDirectLine }) => {
      const executeFetch = async () => {
        const directlineToken = await getDirectLine(userId, username, getNewConversation, fullTokenUrl, accessToken)
        const { token } = directlineToken
        const directline = createDirectLine({ token })
        setDirectLine(directline)
      }
      executeFetch()
    },
    [accessToken]
  )

  const handleReconnectToDirectline = useCallback(
    ({ userId, username, fullTokenUrl, getNewConversation, directLine, setDirectLine }) => {
      const executeFetch = async () => {
        const directlineToken = await getDirectLine(userId, username, getNewConversation, fullTokenUrl, accessToken)
        const { token, streamUrl, conversationId } = directlineToken
        if (directLine) {
          directLine.reconnect({
            token,
            streamUrl,
            conversationId
          })
        } else {
          const directline = createDirectLine({ token })
          setDirectLine(directline)
        }
      }
      executeFetch()
    },
    [accessToken]
  )

  return (
    <div id='tswebchat_container'>
      {oidcUserLoadingState === OidcUserStatus.Loaded ? (
        <Chat
          isAnonymous={isAnonymous}
          urlConfig={urlConfig}
          displayInnerHeader={displayInnerHeader}
          chatbotName={chatbotName}
          displayUserName={displayUserName}
          headerFollowupText={headerFollowupText}
          hideUploadButton={hideUploadButton}
          hideNewConversationButton={hideNewConversationButton}
          botAvatar={botAvatar}
          soundUrl={soundUrl}
          forceAutoscrollOnNewMessage={forceAutoscrollOnNewMessage}
          isDevelopment={isDevelopment}
          headerChatVersion={headerChatVersion}
          emojiSet={emojiSet}
          handleConnectToDirectline={handleConnectToDirectline}
          handleReconnectToDirectline={handleReconnectToDirectline}
          refreshTokenTimeout={refreshTokenTimeout}
        />
      ) : (
        <FakeText lines={10} />
      )}
    </div>
  )
}

ChatLoggedIn.propTypes = {
  isAnonymous: PropTypes.bool.isRequired,
  urlConfig: PropTypes.object.isRequired,
  displayInnerHeader: PropTypes.bool,
  chatbotName: PropTypes.object.isRequired,
  headerFollowupText: PropTypes.object.isRequired,
  hideNewConversationButton: PropTypes.bool.isRequired,
  hideUploadButton: PropTypes.bool,
  botAvatar: PropTypes.object,
  soundUrl: PropTypes.string,
  forceAutoscrollOnNewMessage: PropTypes.bool,
  isDevelopment: PropTypes.bool,
  headerChatVersion: PropTypes.string,
  emojiSet: PropTypes.bool || PropTypes.object,
  refreshTokenTimeout: PropTypes.number
}

export default ChatLoggedIn
